import React, { useState } from 'react';
import { BiMessageSquareAdd } from 'react-icons/bi';
import {
    IoCaretDownSharp,
    IoCaretUpSharp,
    IoWaterOutline,
    IoTrashOutline
} from 'react-icons/io5';
import { PiTextUnderline } from 'react-icons/pi';
import { RiStickyNoteLine } from 'react-icons/ri';
import {
    TfiLayoutLineSolid,
    TfiLineDashed,
    TfiLineDotted
} from 'react-icons/tfi';

import './index.css';

type annotationSHSATHelperProps = {
    id: string;
    annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
        color?: string;
    };
    annotationColor: string;
    setAnnotationColor: (color: string) => void;
    setCurrentAnnotation: (currentAnnotation: null) => void;
    setAnnotation: (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
        color?: string;
    }) => void;
    deleteAnnotation: (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
        color?: string;
    }) => void;
}

function AnnotationSHSATHelper({
    id,
    annotation,
    annotationColor,
    setAnnotationColor,
    setAnnotation,
    deleteAnnotation
}: annotationSHSATHelperProps) {

    const setColor = (color: string) => {
        setAnnotationColor(color);
        setAnnotation({
            ...annotation,
            color: color
        });
    }

    return (
        <div id={id} className='annotationSHSATHelper'>
            <div className='annotationSHSATHelper__functionButton' onClick={() => {
                deleteAnnotation(annotation);
                setAnnotation(null);
            }}>
                <div className='annotationSHSATHelper__delete'/>
            </div>
            <div className='annotationSHSATHelper__functionButton' onClick={() => setColor('Blue')}>
                <div className='annotationSHSATHelper__blue'/>
            </div>
            <div className='annotationSHSATHelper__functionButton' onClick={() => setColor('Pink')}>
                <div className='annotationSHSATHelper__pink'/>
            </div>
        </div>
    );
}

export default AnnotationSHSATHelper;